import { useContextFallback } from '@/hook';

import { ToastContext } from './toast.context';
import { ToastContextState } from './toast.model';

export const useToasts = () => useContextFallback<ToastContextState>(ToastContext);
